// Free-gift progress bar + free-gift line rows for the cart drawer.
// Bar sits above the checkout button; rows render inside the lines <ul>.
import {
        FREEBIE_TIERS,
        freebieHandleForTier,
        freebieLabelFor,
        freebieTierOf,
        lineHandle,
        merchSubtotal,
        tierFor,
} from "../../lib/freebies";

const FMT = new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
        maximumFractionDigits: 0,
});
function money(n) {
        const v = Number(n);
        return Number.isFinite(v) ? FMT.format(v) : "—";
}

export function FreebieBar({ lines }) {
        const subtotal = merchSubtotal(lines);
        if (subtotal <= 0) return null;
        const tier = tierFor(subtotal);
        const nextTier = FREEBIE_TIERS.find((t) => t.min > subtotal) || null;
        const maxMin = FREEBIE_TIERS[FREEBIE_TIERS.length - 1].min;
        const target = nextTier ? nextTier.min : maxMin;
        const pct = Math.max(3, Math.min(100, Math.round((subtotal / target) * 100)));
        const giftLabel = tier > 0 ? freebieLabelFor(freebieHandleForTier(tier, lines)) : null;

        return (
                <div
                        data-testid="cart-freebie-bar"
                        className="border border-white/10 bg-white/[0.03] px-4 py-3"
                >
                        {tier > 0 ? (
                                <p
                                        data-testid="cart-freebie-message"
                                        className="font-mono text-[10px] tracking-[0.14em] uppercase text-[#FF9F1C]"
                                >
                                        Free gift unlocked · Tier {tier} — {giftLabel}
                                </p>
                        ) : (
                                <p
                                        data-testid="cart-freebie-message"
                                        className="font-mono text-[10px] tracking-[0.14em] uppercase text-white/70"
                                >
                                        Add {money(nextTier.min - subtotal)} more to unlock a free gift
                                </p>
                        )}
                        <div className="mt-2 h-1.5 w-full bg-white/10">
                                <div
                                        data-testid="cart-freebie-bar-fill"
                                        className="h-full bg-[#FF9F1C] transition-[width] duration-500"
                                        style={{ width: `${pct}%` }}
                                />
                        </div>
                        <p
                                data-testid="cart-freebie-submessage"
                                className="mt-2 font-mono text-[9px] tracking-[0.14em] uppercase text-white/45"
                        >
                                {nextTier
                                        ? tier > 0
                                                ? `Add ${money(nextTier.min - subtotal)} more for tier ${nextTier.tier}`
                                                : `Tier 1 free gift at ${money(nextTier.min)}`
                                        : "Max tier reached — your gift ships free with the order"}
                        </p>
                </div>
        );
}

export function FreebieRow({ line, onRemove }) {
        const title = freebieLabelFor(lineHandle(line)); // curated label, not the raw Shopify title
        const tier = freebieTierOf(line);
        const img = line?.merchandise?.image?.url || line?.merchandise?.product?.featuredImage?.url || null;
        return (
                <li
                        data-testid="cart-freebie-row"
                        className="flex items-center gap-3 border border-[#FF9F1C]/30 bg-[#FF9F1C]/[0.06] px-3 py-3"
                >
                        <div className="shrink-0 w-[52px] h-[52px] border border-white/10 bg-[#111] flex items-center justify-center overflow-hidden">
                                {img ? (
                                        <img
                                                src={img}
                                                alt={title}
                                                loading="lazy"
                                                className="max-w-full max-h-full object-contain p-1"
                                        />
                                ) : (
                                        <span className="text-white/25 font-display text-[18px]">{title.slice(0, 1)}</span>
                                )}
                        </div>
                        <div className="flex-1 min-w-0">
                                <h3 className="font-sans text-[13px] font-semibold text-white leading-tight truncate">
                                        {title}
                                </h3>
                                <p
                                        data-testid="cart-freebie-badge"
                                        className="mt-1 inline-block font-mono text-[9px] tracking-[0.14em] uppercase text-[#FF9F1C] border border-[#FF9F1C]/60 px-1.5 py-0.5"
                                >
                                        Free gift{tier ? ` · Tier ${tier}` : ""}
                                </p>
                        </div>
                        <span className="font-mono text-[12px] text-white/70 tabular-nums">₹0</span>
                        <button
                                type="button"
                                data-testid="cart-freebie-row-remove"
                                aria-label={`Remove free gift ${title}`}
                                onClick={() => onRemove(line)}
                                className="text-white/40 hover:text-[#FF9F1C] transition-colors p-1 font-mono text-[14px] leading-none"
                        >
                                ✕
                        </button>
                </li>
        );
}
